module.exports = __webpack_public_path__ + "img/setSignImg.95b9df16.png";